import { BaseDto } from "./base.dto"

export class CreateFeaturedTenantDto extends BaseDto {
  tenantId: string
  mallId?: string
}

export class SortOrderFeaturedTenantDto extends BaseDto {
  tenantIds: string[]
  mallId?: string
}